/**
 * Cryptique theme for Analytics (light mode).
 * Matches Cryptique brand: Deep Indigo + gradient blue.
 */
export const cryptiqueAnalyticsTheme = {
  // Brand colors (from Cryptique design system)
  primary: "#1d0c46",       // Deep Indigo
  primaryLight: "#4B57AA",  // Gradient blue (vibrant accent)
  primaryHover: "#361a6f",  // Darker indigo on hover
  secondary: "#caa968",     // Muted Gold

  // Light UI
  bgBase: "#f8fafc",
  bgRaised: "#ffffff",
  bgOverlay: "#f1f5f9",
  border: "#DDE2EE",
  borderMuted: "rgba(0,0,0,0.06)",

  // Text (darker: 0f172a, lighter/grey: 475569)
  textPrimary: "#0f172a",
  textSecondary: "#475569",
  textMuted: "#475569",

  // Accents
  accentPositive: "#059669",
  accentChart: "#1d0c46",
  accentChartMuted: "rgba(29, 12, 70, 0.5)",
};
